import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import dayjs from 'dayjs'

import 'dayjs/locale/fr'
import 'dayjs/locale/en'
import 'dayjs/locale/es'

dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.locale(localStorage.getItem('user-preferred-lang') ?? 'en')

const filters = {
    formatDate(_string, _format = 'L', option = '') {
        if (option === 'fromNow') {
            return dayjs(_string).fromNow()
        } else {
            return dayjs(_string).format(_format)
        }
    },

    capitalized(_string) {
        if (_string && _string.length) {
            const capitalizedFirst = _string[0].toUpperCase()
            const rest = _string.slice(1)
            return capitalizedFirst + rest
        }
    },

    truncateText(text, length = 50, clamp = '...') {
        return text.length > length ? text.slice(0, length) + clamp : text
    },
}

export default filters
